// Espelho no navegador do cálculo de preço com cupom (supabase/functions/_shared/pricing.ts).
// Serve para a prévia ao criar o cupom no painel; quem cobra de verdade é sempre o servidor.
// Mantenha os valores iguais aos de supabase/functions/_shared/asaas.ts.

export const IMPLEMENTATION_FEE = 399;
export const MONTHLY_FEE = 150;
export const EXTRA_USER_FEE = 39.9;
export const INCLUDED_USERS = 2;
/** O Asaas não cobra abaixo disso. */
export const MIN_CHARGE = 5;

export type DiscountType = 'none' | 'percent' | 'fixed';

export interface CouponBenefits {
    implementation_discount_type: DiscountType;
    implementation_discount_value: number;
    monthly_discount_type: DiscountType;
    monthly_discount_value: number;
    free_months: number;
}

export interface CouponPricing {
    implementation: number;
    monthly: number;
    freeMonths: number;
}

const round2 = (n: number) => Math.round(n * 100) / 100;

function applyDiscount(base: number, type: DiscountType, value: number): number {
    if (type === 'percent') return round2(base * (1 - value / 100));
    if (type === 'fixed') return Math.max(0, round2(base - value));
    return base;
}

export function computeCouponPricing(b: CouponBenefits): CouponPricing {
    return {
        implementation: applyDiscount(IMPLEMENTATION_FEE, b.implementation_discount_type, b.implementation_discount_value),
        monthly: applyDiscount(MONTHLY_FEE, b.monthly_discount_type, b.monthly_discount_value),
        freeMonths: b.free_months,
    };
}

/** Mensagem de erro se o cupom resultar em valores que o Asaas não consegue cobrar; null se estiver ok. */
export function validateCouponPricing(p: CouponPricing): string | null {
    if (p.implementation > 0 && p.implementation < MIN_CHARGE) {
        return `A implantação ficaria em R$ ${p.implementation.toFixed(2).replace('.', ',')}. O mínimo cobrável é R$ ${MIN_CHARGE},00 (ou use 100% de desconto para grátis).`;
    }
    if (p.monthly < MIN_CHARGE) {
        return `A mensalidade ficaria abaixo do mínimo cobrável (R$ ${MIN_CHARGE},00). Para não cobrar por um tempo, use "meses grátis".`;
    }
    return null;
}

export const brl = (n: number) => n.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });

/** "2º mês", "4º mês"... em que a primeira mensalidade é cobrada. */
export const firstMonthlyChargeMonth = (freeMonths: number) => 2 + freeMonths;

export function describeDiscount(type: DiscountType, value: number): string | null {
    if (type === 'percent' && value > 0) return `${String(value).replace('.', ',')}%`;
    if (type === 'fixed' && value > 0) return brl(value);
    return null;
}
